// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___1MWK","option":"styles_option__3d7Zs","active":"styles_active__3SDlL"};